<template>
<div >






<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>



<div class="mt-4" v-if="!loading" style="min-height:450px">


<ClickEditInputText  :title="$store.state.languages.lang_phrases.isim" :value="item.name" valkey="name" @dataChanged="dataChanged"></ClickEditInputText>



</div>


</div>
</template>

<script>

export default {

  name: 'CertificatetypeGeneral',

  data () {
    return {    	
      item:null,
      loading:true,
    }
  },
  mounted()
  {    
    this.getData()
  },
  methods:{
   
  	async getData()
    {
      this.loading = await true
       this.item = await this.generalApiGetWithoutLoader("certificatetype/"+this.$route.params.id)       
       this.loading = await false
    },   
     dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      let formdata = new FormData()
      formdata.append(data.key,data.value)
      this.generalSubmission(formdata,"certificatetype/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log(response.data);
      this.item = response.data
      this.$store.dispatch('certificatetypes/serCertificateType',this.item) 
      
    }
  }
};
</script>

<style lang="css" scoped>
</style>